module.exports = __webpack_public_path__ + "img/home.5d522309.svg";